
import { Options, Vue } from "vue-class-component";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import convertArrayToString from "@/app/infrastructures/misc/common-library/ConvertArrayToString";
import prefixAlgoEstimationShow from "@/app/infrastructures/misc/common-library/PrefixAlgoEstimationShow";
import convertDecimalWithComma from "@/app/infrastructures/misc/common-library/ConvertDecimalWithComma";
import Multiselect from "@/app/ui/components/multiselect-search-tag/index.vue";
import generateThermalPDF from "./modules/bulk-label-resi-thermal";
import generatePDF from "./modules/bulk-label-resi-pdf";
import JsBarcode from "jsbarcode";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ListSttController } from "@/app/ui/controllers/ListSttController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  payloadOfThermalData,
  downloadFilePrn
} from "@/app/infrastructures/misc/UtilsThermal";
import flatten from "lodash/flatten";
import { ListSttData } from "@/domain/entities/ListStt";
import isFormatLiloBag from "@/app/infrastructures/misc/common-library/isFormatLiloBag";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { FlagsPermissionBulkPrint } from "@/feature-flags/flag-bulk-print";
import { ShipmentBooking } from "@/domain/entities/ShipmentBooking";
import { isInterpackInternationalProduct } from "@/app/infrastructures/misc/common-library/DetectLanguage";

const BULK_PRINT_STT_PICKER_LIMIT = 20;
const BULK_PRINT_STT_DEFAULT_MAX = 500;

@Options({
  components: {
    EmptyState,
    Multiselect
  }
})
class BulkPrintResi extends Vue {
  mounted() {
    this.onRequest();
    this.sttListValue = [];
    this.duplicateRemovedCount = 0;
    this.cacheSttNo = [];
    ListSttController.resetSttList();
    ListSttController.setShowTable(false);
  }

  get getCurrentRoute() {
    return this.$t(String(this.$route.meta.name));
  }

  cacheSttNo: any[] = [];
  isRefresh() {
    let isExist = true;
    for (let i = 0; i < this.sttListValue.length; i++) {
      const isAny = this.cacheSttNo.find(
        (e) => e.id === this.sttListValue[i].id
      );
      if (!isAny) {
        isExist = false;
        break;
      }
    }
    return this.cacheSttNo.length > 0 &&
      this.sttListValue.length > 0 &&
      (!isExist || this.sttListValue.length !== this.cacheSttNo.length)
      ? "refresh-white"
      : "";
  }

  // get client / partner name
  get clientPartnerName() {
    return AccountController.accountData.name;
  }

  isSttNumber(sttNumber: string) {
    return /^\d{1,2}LP\w+$/g.test(sttNumber.trim());
  }

  isLiloBag(bagNo: string) {
    return isFormatLiloBag(bagNo);
  }

  get listSttScan() {
    if (!this.sttListValue.length) {
      return [];
    }
    return this.sttListValue.filter((item) => !this.isLiloBag(item.name));
  }

  get listBagScan() {
    if (!this.sttListValue.length) {
      return [];
    }
    return this.sttListValue.filter((item) => this.isLiloBag(item.name));
  }

  // Generate Function
  get isTableShow() {
    return ListSttController.isTableShow;
  }

  get hasInternationalCommercialInvoice() {
    return ListSttController.resiListData.some((stt) => stt.isInternational === true);
  }

  // get list table stt
  getListSttTable() {
    ListSttController.getListStt({
      page: 1,
      limit: this.maxSttInput,
      destinationCityId: 0,
      userType: "",
      bookedBy: "",
      bookedType: "",
      fromDate: "",
      endDate: "",
      sttNumber: convertArrayToString(this.listSttScan, "name")
    });
  }

  getListBagTable() {
    ListSttController.getListBag({
      bagNumber: convertArrayToString(this.listBagScan, "name")
    });
  }

  get sumTotalCharge() {
    let total = 0;
    this.listData?.map((e) => {
      if (!this.estimationBound(e.sttShipmentId, e.sttClientId)) {
        total += Number(
          e.sttDocumentSurchargeRate +
            e.sttHeavyweightSurchargeRate +
            e.sttCommoditySurchargeRate +
            e.sttWoodpackingRate +
            e.sttShippingSurchargeRate +
            e.sttPublishRate +
            e.sttDestinationDistrictRate +
            e.sttOriginDistrictRate +
            e.sttTotalInsurance +
            e.sttCodFee
        );
      }
    });
    return total > 0 ? this.formatPrice(total, this.userCurrency) : "-";
  }

  get sumTotalChargeAfterDiscount() {
    let total = 0;
    this.listData?.map((e) => {
      if (!this.estimationBound(e.sttShipmentId, e.sttClientId)) {
        total += Number(e.sttTotalAmountAfterDiscount);
      }
    });
    return total > 0 ? this.formatPrice(total, this.userCurrency) : "-";
  }

  clearSttListValue() {
    if (this.sttListValue.length === 0) {
      this.dataToBePrint = [];
      ListSttController.resetErrorMessage("");
      ListSttController.resetSttList();
      ListSttController.setShowTable(false);
    }
  }
  dataToBePrint = [];

  // Table
  get listData() {
    if (this.listBagScan.length && !this.isRefresh()) {
      this.listBagData.forEach((item) => {
        const currentIdx = ListSttController.sttList?.data.findIndex(
          (exist) => exist.sttNo === item.bagCode
        );
        if (currentIdx === -1) {
          return ListSttController.sttList?.data.push(
            new ListSttData({
              sttId: item.bagId,
              sttNo: item.bagCode,
              sttTotalPiece: item.bagTotalPiece,
              sttChargeableWeight: item.bagTotalGrossWeight,
              sttRecipientAddress: "-",
              sttSenderName: "-",
              sttRecipientName: "-",
              sttIsInsurance: false,
              sttIsCod: false,
              sttShipmentId: ""
            })
          );
        }
      });
    }
    return ListSttController.sttList?.data;
  }
  get listSttData() {
    return ListSttController.sttList?.data;
  }
  get listBagData() {
    return ListSttController.bagList?.data;
  }
  get pagination() {
    return ListSttController.sttList?.pagination;
  }
  get columns() {
    return [
      {
        name: "No",
        styleHead: "w-10 font-semibold text-14px text-left",
        styleBody: "text-center",
        render: (item: ListSttData, index: number) => {
          return `<div class='text-left text-black-lp-200 text-14px'>${index + 1}</div>`;
        }
      },
      {
        name: "No. STT",
        styleHead: "w-44 font-semibold text-14px text-left whitespace-no-wrap",
        styleBody: "text-center",
        render: (item: ListSttData) => {
          return `<div class='text-left text-black-lp-200 text-14px whitespace-no-wrap'>${item.sttNo}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.noRef"),
        styleHead: "w-40 font-semibold text-14px text-left whitespace-no-wrap",
        styleBody: "text-center",
        render: (item: ListSttData) => {
          return `<div class='text-left text-black-lp-200 text-14px whitespace-no-wrap'>${
            !item.sttNoRefExternal ? "-" : item.sttNoRefExternal
          }</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.shipmentNo"),
        styleHead: "w-40 font-semibold text-14px text-left whitespace-no-wrap",
        styleBody: "text-center",
        render: (item: ListSttData) => {
          return `<div class='text-left text-black-lp-200 text-14px whitespace-no-wrap'>${
            !item.sttShipmentId ? "-" : item.sttShipmentId
          }</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.totalPieces"),
        styleHead: "w-32 font-semibold text-14px text-left whitespace-no-wrap",
        render: (item: ListSttData) => {
          return `<div class='flex text-black-lp-200 text-14px text-center'>${item.sttTotalPiece}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.totalChargeableWeight"),
        styleHead: "w-72 font-semibold text-14px text-left",
        render: (item: ListSttData) => {
          return `<div class='flex text-black-lp-200 text-14px'>${formatByCountry(
            item.sttChargeableWeight,
            {
              type: "weight",
              country: item.sttBookedByCountry,
              suffix: " kg"
            }
          )}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.destinationAddress"),
        styleHead: "w-64 font-semibold text-14px text-left whitespace-no-wrap",
        render: (item: ListSttData) => {
          return `<div class="overflow-ellipsis text-black-lp-200 text-14px">${ellipsisString(
            item.sttDestinationCityCode,
            30
          )}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.sender"),
        styleHead: "w-68 font-semibold text-14px text-left",
        render: (item: ListSttData) => {
          return `<div class='flex text-black-lp-200 text-14px break-all'>${ellipsisString(
            item.sttSenderName,
            45
          )}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.recipient"),
        styleHead: "w-68 font-semibold text-14px text-left",
        render: (item: ListSttData) => {
          return `<div class="text-black-lp-200 text-14px flex break-all">${ellipsisString(
            item.sttRecipientName,
            78
          )}</div>`;
        }
      },
      {
        name: this.$t("bulkPrintReceipt.table.totalTarif"),
        styleHead: "w-40 font-semibold text-14px text-left",
        render: (item: ListSttData) => {
          return this.totalAmount(item);
        }
      }
    ];
  }

  // handling
  get maxSttInput() {
    const limit = Number(
      FlagsPermissionBulkPrint.config_max_stt_input_bulk_print.getValue()
    );
    return limit > 0 ? limit : BULK_PRINT_STT_DEFAULT_MAX;
  }
  get excessSttCount() {
    return Math.max(this.sttListValue.length - this.maxSttInput, 0);
  }
  get isOverSttLimit() {
    return this.excessSttCount > 0;
  }
  get hasSttLookupError() {
    return ListSttController.isError;
  }
  get isLoading() {
    return ListSttController.isLoading;
  }
  get isError() {
    return this.hasSttLookupError || this.isOverSttLimit;
  }
  get errorCause() {
    return ListSttController.isErrorCause;
  }
  get errorMessageLength() {
    return ListSttController.errorMessageList.split(",").length;
  }
  get errorMessageList() {
    return ListSttController.errorMessageList;
  }

  // Fetch No. STT
  sttListValue: any[] = [];
  duplicateRemovedCount = 0;
  isLoadingMoreStt = false;
  get setErrorList() {
    const error = ListSttController.errorMessageList;
    this.sttListValue = this.sttListValue.map((item, index) => {
      return {
        ...item,
        isError: index >= this.maxSttInput || error.includes(item.name)
      };
    });
    return "";
  }

  resetBagList() {
    ListSttController.resetBagList();
  }

  resetResiListData() {
    ListSttController.resetResiListData();
  }

  onGenerate() {
    if (this.isOverSttLimit) return;
    this.resetBagList(); // reset listbagData
    this.resetResiListData(); // reset resiListData
    if (this.listSttScan.length) {
      this.getListSttTable();
    }
    if (this.listBagScan.length) {
      this.getListBagTable();
    }
    this.cacheSttNo = this.sttListValue;
    ListSttController.resetErrorMessage("");
  }
  async onRequest() {
    await ShipmentBookingController.fetchBulkPrintShipmentBooking({
      page: 1,
      limit: BULK_PRINT_STT_PICKER_LIMIT,
      search: "",
      append: false
    });
  }

  get sttManualList() {
    return ShipmentBookingController.shipmentBookingData.data.map((e) => ({
      name: e.sttNo,
      id: e.sttNo,
      isError: false
    }));
  }

  shippingCost(data: ListSttData) {
    return this.formatPrice(
      data.sttShippingSurchargeRate +
        data.sttPublishRate +
        data.sttDestinationDistrictRate +
        data.sttOriginDistrictRate,
      data.sttBookedByCountry
    );
  }

  amountSurcharge(data: ListSttData) {
    return this.formatPrice(
      data.sttDocumentSurchargeRate +
        data.sttHeavyweightSurchargeRate +
        data.sttCommoditySurchargeRate +
        data.sttWoodpackingRate +
        data.sttCodFee,
      data.sttBookedByCountry
    );
  }

  totalAmount(data: ListSttData) {
    if (this.estimationBound(data.sttShipmentId, data.sttClientId)) {
      return `<div class="text-red-lp-510 flex font-semibold">-</div>`;
    }
    if (data.sttIsPromo) {
      return `<div class="text-gray-lp-600 flex font-semibold">
        <s>${this.totalAmountWithoutDiscount(data)}</s>
      </div>
      <div class="text-red-lp-100 flex font-semibold">
        ${this.formatPrice(
          data.sttTotalAmountAfterDiscount,
          data.sttBookedByCountry
        )}
      </div>`;
    }
    return `<div class="text-red-lp-510 flex font-semibold">${this.totalAmountWithoutDiscount(data)}</div>`;
  }

  totalAmountWithoutDiscount(data: ListSttData) {
    return this.formatPrice(
      data.sttDocumentSurchargeRate +
        data.sttHeavyweightSurchargeRate +
        data.sttCommoditySurchargeRate +
        data.sttWoodpackingRate +
        data.sttShippingSurchargeRate +
        data.sttPublishRate +
        data.sttDestinationDistrictRate +
        data.sttOriginDistrictRate +
        data.sttTotalInsurance +
        data.sttCodFee,
      data.sttBookedByCountry
    );
  }

  get isLoadingSttManual() {
    return ShipmentBookingController.isLoading;
  }

  onSearch(value: any) {
    ShipmentBookingController.fetchBulkPrintShipmentBooking({
      page: 1,
      limit: BULK_PRINT_STT_PICKER_LIMIT,
      search: value,
      append: false
    });
  }

  onDuplicatesRemoved(count: any) {
    this.duplicateRemovedCount = count;
  }

  deleteAll() {
    this.sttListValue = [];
    this.cacheSttNo = [];
    this.dataToBePrint = [];
    ListSttController.resetErrorMessage("");
    this.duplicateRemovedCount = 0;
    ListSttController.resetSttList();
    ListSttController.setShowTable(false);
  }

  get countryCode() {
    return AccountController.accountData.countryCode.toLowerCase();
  }

  async printDoc(type: string) {
    const listSttPieces: any[] = [];

    ListSttController.resiListData.forEach((item, index) => {
      if (item) {
        const barcode = document.createElement("img");
        const vendorBarcode = document.createElement("img");
        JsBarcode(barcode, item.sttNo, {
          textAlign: "left",
          displayValue: false,
          fontSize: 16
        });
        if (item.sttVendorRefferenceNo) {
          // vendor ref code
          JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
        }

        item.sttPieces.forEach((e) => {
          listSttPieces.push({
            ...e,
            ...item,
            barcode: barcode.src,
            vendorRefCode: vendorBarcode.src
          });
        });

        barcode.remove();
        vendorBarcode.remove();
      }
    });

    if (listSttPieces.length || this.listBagData.length) {
      new Promise(function(resolve) {
        MainAppController.showLoading();
        setTimeout(resolve.bind(null, null), 1);
      }).then(() => {
        const accountType = AccountController.accountData.account_type;
        if (type === "thermal-pdf") {
          generateThermalPDF(
            accountType,
            listSttPieces,
            this.listBagData as any,
            true,
            this.countryCode as any
          );
        } else {
          generatePDF(
            accountType,
            listSttPieces,
            this.listBagData as any,
            this.countryCode as any
          );
        }

        MainAppController.closeLoading();
      });
    }
  }

  async printInvoice(sttId = 0, sttNo = "", pageSize = "a4") {
    const book = await import(
      "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
    ) as any;
    book.default.methods.directPrintInterpack(sttId, sttNo, pageSize);
  }

  async printBulkInvoice(pageSize = "a4") {
    const internationalPrintData = (ListSttController.resiListData || []).filter(
      (item) => item.isInternational === true
    );
    if (!internationalPrintData.length) return;

    const book = await import(
      "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
    ) as any;
    await new Promise(resolve => {
      MainAppController.showLoading();
      setTimeout(resolve, 1);
    });
    // ponytail: setTimeout(1) over $nextTick — gives the browser a macrotask
    // to paint the loading overlay; $nextTick only flushes Vue microtasks and
    // resolves before the overlay actually renders.
    try {
      await book.default.methods.bulkPrintInterpack(internationalPrintData, pageSize);
    } finally {
      MainAppController.closeLoading();
    }
  }

  async printComercialA6() {
    this.printBulkInvoice("a6");
  }

  async printComercialA4() {
    this.printBulkInvoice("a4");
  }

  // print thermal
  get resiListData() {
    const listSttPieces: any[] = [];
    ListSttController.resiListData.forEach((item) => {
      item.sttPieces.forEach((e) => listSttPieces.push(e));
    });
    return listSttPieces;
  }

  printThermal() {
    const payloadPushed: any[] = [];
    const accountType = AccountController.accountData.account_type;
    ListSttController.resiListData.forEach((item, index) => {
      if (item) {
        payloadPushed.push(
          payloadOfThermalData(item, accountType).map((e) => ({
            ...e,
            isHubToHub: item.isHubToHub,
            sttBookedForName: item.sttBookedForName,
            otherShipperTicketCode: item.otherShipperTicketCode,
            sttIsCodRetail:
              !item.sttShipmentId &&
              !item.sttClientId &&
              (accountType === "partner" || accountType === "internal") &&
              e.sttIsCod
          }))
        );

        if (index === ListSttController.resiListData.length - 1) {
          new Promise((resolve) => {
            MainAppController.showLoading();
            setTimeout(resolve.bind(null, null), 1);
          }).then(() => {
            const payloadResult = flatten(payloadPushed);
            downloadFilePrn(payloadResult, this.countryCode, false);
            MainAppController.closeLoading();
          });
        }
      }
    });
  }

  get accountType() {
    return AccountController.accountData.account_type;
  }

  estimationBound(shipmentId: string, clientId: any) {
    if (
      shipmentId &&
      !prefixAlgoEstimationShow(shipmentId) &&
      this.accountType === "partner"
    ) {
      // shipment type by pos
      return true;
    } else if (
      !shipmentId &&
      clientId === 0 &&
      this.accountType === "partner"
    ) {
      // manual type by pos
      return false;
    } else if (!shipmentId && clientId === 0 && this.accountType === "client") {
      // manual type by client
      return true;
    } else if (
      !shipmentId &&
      clientId !== 0 &&
      this.accountType === "partner"
    ) {
      // client type by pos
      return true;
    } else if (
      !shipmentId &&
      clientId !== 0 &&
      this.accountType === "internal"
    ) {
      // client type by internal
      return true;
    } else
      return !shipmentId && clientId !== 0 && this.accountType === "client";
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }

  get userCurrency() {
    return AccountController.accountData.accountCurrency;
  }

  formatPrice(value: number, country: string) {
    return formatByCountry(value, {
      type: "money",
      country,
      prefix: country?.toUpperCase() === "MY" ? "RM" : "Rp"
    });
  }

  get hasMoreSttManual() {
    const { data, pagination } = ShipmentBookingController.shipmentBookingData;
    return data.length < (pagination.totalData ?? 0);
  }

  async onLoadMoreStt() {
    if (
      this.isLoadingMoreStt ||
      this.isLoadingSttManual ||
      !this.hasMoreSttManual
    ) {
      return;
    }

    const pagination =
      ShipmentBookingController.shipmentBookingData.pagination;
    const currentPage = pagination.page;
    this.isLoadingMoreStt = true;

    try {
      await ShipmentBookingController.fetchBulkPrintShipmentBooking({
        page: currentPage + 1,
        limit: BULK_PRINT_STT_PICKER_LIMIT,
        search: ShipmentBookingController.search,
        append: true
      });
    } finally {
      if (ShipmentBookingController.isError) {
        ShipmentBookingController.setShipmentBookingPagination({
          page: currentPage,
          limit: BULK_PRINT_STT_PICKER_LIMIT
        });
      }
      this.isLoadingMoreStt = false;
    }
  }
}

export default BulkPrintResi;
